/**
 * StaffWhereaboutsPending — soft staff approval queue.
 *
 * Children who tapped a whereabouts on the kiosk while approval mode is ON
 * surface here. Tap Confirm to apply the state; Set aside to dismiss.
 */
import { Sparkles } from "lucide-react";

const STATE_LABEL_MAP = {
  learning: "Yard",
  playing: "Play",
  eating: "Eat",
  resting: "Rest",
  safe: "In Care",
};

export default function StaffWhereaboutsPending({ items, onApprove, onReject }) {
  if (!items?.length) return null;
  return (
    <section
      data-testid="staff-whereabouts-pending"
      className="mt-10"
    >
      <div className="flex items-center gap-2">
        <Sparkles size={14} strokeWidth={1.5} className="text-[#8A9984]" />
        <span className="eyebrow">Gentle shares from the children</span>
      </div>
      <ol data-testid="staff-whereabouts-list" className="mt-3 space-y-2">
        {items.map((p) => (
          <li
            key={p.id}
            data-testid={`staff-whereabouts-row-${p.id}`}
            className="rounded-2xl border hairline bg-white p-4 flex items-center gap-3 flex-wrap"
            style={{ borderLeft: "3px solid #A89CC8" }}
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm text-[#2C2B29] leading-snug">
                <span className="font-serif">{p.child_name}</span>
                <span className="text-[#6A6863]">
                  {" "}gently shared they're at{" "}
                </span>
                <span className="font-serif">
                  {STATE_LABEL_MAP[p.state] || p.state}
                </span>
                <span className="text-[#6A6863]"> · via {p.by_user_name}</span>
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => onApprove(p)}
                data-testid={`staff-whereabouts-approve-${p.id}`}
                className="btn-primary !py-1.5 !px-3 !text-[10px]"
              >
                Confirm
              </button>
              <button
                type="button"
                onClick={() => onReject(p)}
                data-testid={`staff-whereabouts-reject-${p.id}`}
                className="btn-ghost !py-1.5 !px-3 !text-[10px]"
              >
                Set aside
              </button>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
